import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".document-allposit-thumb_svg__cls-1{fill:#5f7cf9}.document-allposit-thumb_svg__cls-3{fill:#4062ed}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<g id=\"document-allposit-thumb_svg__Image\"><rect width=\"28\" height=\"20\" x=\"2\" y=\"6\" class=\"document-allposit-thumb_svg__cls-1\" rx=\"1\" ry=\"1\"></rect><path d=\"M30 16.58V25a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-.5l12.4-9.3a1 1 0 0 1 1.2 0l3.31 2.48 5.38-5.39a1 1 0 0 1 1.42 0Z\" style=\"fill:#8c9eff;\"></path><path d=\"M19 13a1 1 0 0 1-.38-.08 1.2 1.2 0 0 1-.33-.21 1 1 0 0 1-.21-1.09.9.9 0 0 1 .54-.54.93.93 0 0 1 .57-.06.6.6 0 0 1 .19.06.8.8 0 0 1 .18.09l.15.12a1.2 1.2 0 0 1 .21.33 1 1 0 0 1-.21 1.09 1.2 1.2 0 0 1-.33.21A1 1 0 0 1 19 13\" class=\"document-allposit-thumb_svg__cls-3\"></path><path d=\"M29 6H19v20h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1\" class=\"document-allposit-thumb_svg__cls-3\"></path><path d=\"m19.71 11.29-.15-.12a.8.8 0 0 0-.18-.09.6.6 0 0 0-.19-.06H19v2a1 1 0 0 0 .38-.08 1.2 1.2 0 0 0 .33-.21 1 1 0 0 0 .21-1.09 1.2 1.2 0 0 0-.21-.35\" style=\"fill:#2f58dd;\"></path><path d=\"M24.29 12.29 19 17.59V26h10a1 1 0 0 0 1-1v-8.42l-4.29-4.29a1 1 0 0 0-1.42 0\" class=\"document-allposit-thumb_svg__cls-1\"></path></g>", 1)),
    _cache[2] || (_cache[2] = _createElementVNode("g", { fill: "#FFF" }, [
      _createElementVNode("path", {
        "xmlns:ns0": "http://www.w3.org/2000/svg",
        d: "m13.604 11.712-.897-2.69-1.344-.615.093-.204 1.432.656.929 2.783zM15.179 21.74l-1.462-.647.09-.205 1.419.628 2.198-.004v.224z"
      }),
      _createElementVNode("path", {
        "xmlns:ns0": "http://www.w3.org/2000/svg",
        d: "m17.424 21.735-1.516-.651.089-.206 1.296.557 4.398-12.42-1.249-.613.099-.2 1.428.7-.036.105zM12.955 13.38l.092-.205 1.445.651-.092.204z"
      }),
      _createElementVNode("path", {
        "xmlns:ns0": "http://www.w3.org/2000/svg",
        d: "M14.444 13.812h2.086v.224h-2.086z"
      }),
      _createElementVNode("path", {
        "xmlns:ns0": "http://www.w3.org/2000/svg",
        d: "m14.338 13.96.212-.073 1.047 3.057-.212.073z"
      }),
      _createElementVNode("g", { "xmlns:ns0": "http://www.w3.org/2000/svg" }, [
        _createElementVNode("path", { d: "M16.023 21.093h-2.306l-.026-.075L9.199 8.203h2.257l1.105 3.362h4.635l1.138-3.362 2.208-.003zm-2.147-.224h1.988l4.362-12.444-1.731.002-1.137 3.362h-4.96l-1.104-3.362h-1.78z" }),
        _createElementVNode("path", { d: "M14.997 18.784h-.245l-1.911-5.623h4.066zm-1.844-5.399 1.721 5.064 1.72-5.064z" })
      ])
    ], -1))
  ]))
}
export default { render: render }